<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>OPB Companies List</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search }
      </button>
      <button mat-raised-button color="primary" [disabled]="isExporting" (click)="onExportToCsv()">
        <mat-icon>insert_chart_outlined</mat-icon>
        CSV Export
      </button>
      <button mat-raised-button color="primary" (click)="onImportCsv()">
        <mat-icon>upload_file</mat-icon>
        CSV Import
      </button>
      <button mat-raised-button color="accent" (click)="onCreateCompany()">
        <mat-icon>add</mat-icon>
        Add OPB Company
      </button>
    </div>
  </div>
  <app-opb-company-search-box
    [isSearchVisible]="isSearchVisible"
    [initialFilter]="currentSearchFilter"
    (searchFilter)="onSearchFilterChange($event)">
  </app-opb-company-search-box>
  <app-generic-list
    [items]="companies"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [enableEdit]="true"
    [enableDelete]="true"
    [enableTransfer]="true"
    [transferDisabledField]="'isTransferred'"
    (editClick)="onEditCompany($event)"
    (deleteClick)="onDeleteCompany($event)"
    (transferClick)="onTransferCompany($event)"
    [serverSidePagination]="true"
    [totalItems]="totalItems"
    [currentPage]="currentPage"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)">
  </app-generic-list>
</div>
